import { reactive } from "vanjs-ext";
import { router } from "..";
import { impersonate } from "../api/admin";
import { getFenceAlarm2, putFencealarm2Fota } from "../api/fencealarm2s_{imei}";
import { state } from "../state";
import { centeredBox } from "../van/centered-box";
import { a, button, div, hr, input, li, nav, pre, ul } from "../van/van-tags";
import { errorToast } from "../view/components";
import { putFa2Trial } from "./fa2-api";

/**
 * @param {import("navigo").Match} ctx
 */
export async function adminFa2Page(ctx) {
	if (!ctx.data?.imei) throw "missing ctx.data.imei";

	const page = reactive({
		fa2: await getFenceAlarm2(ctx.data.imei),
		fota: {
			checksum: "",
			url: "coap://<host>:5683/<fw>",
		},
		loading: false,
		trial: {
			days: "",
		},
	});

	const onClickAddTrial = () => {
		page.loading = true;
		putFa2Trial(page.fa2.Imei, +page.trial.days)
			.then((fa2) => {
				page.fa2 = fa2;
			})
			.catch(errorToast)
			.finally(() => {
				page.loading = false;
			});
	};

	const onClickImpersonate = () => {
		page.loading = true;
		impersonate("fencealarm2", page.fa2.Imei)
			.then((user) => state.startImpersonating(user))
			.then(() => router.jump("/devices"))
			.catch(errorToast)
			.finally(() => {
				page.loading = false;
			});
	};

	const onClickUploadFota = () => {
		page.loading = true;
		putFencealarm2Fota(page.fa2.Imei, {
			Checksum: page.fota.checksum,
			Url: page.fota.url,
		})
			.catch(errorToast)
			.finally(() => {
				page.loading = false;
			});
	};

	return centeredBox(
		{
			size: "narrow",
		},
		nav(
			{
				class: "breadcrumb",
			},
			ul(
				li(
					a(
						{
							onclick: () => router.jump("/admin"),
						},
						"Admin",
					),
				),
				li(a("FenceAlarm2")),
			),
		),
		div(
			{
				class: "buttons",
			},
			button(
				{
					class: () =>
						page.loading
							? "button is-primary is-loading"
							: "button is-primary",
					disabled: () => page.loading,
					onclick: onClickImpersonate,
				},
				"Impersonate owner",
			),
		),
		div(
			{
				class: "field has-addons",
			},
			div(
				{
					class: "control is-expanded",
				},
				input({
					class: "input",
					oninput: (e) => {
						page.trial.days = e.target.value.replace(/\D/g, "");
						e.target.value = page.trial.days;
					},
					placeholder: "Days",
				}),
			),
			div(
				{
					class: "control",
				},
				button(
					{
						class: () =>
							page.loading
								? "button is-primary is-loading"
								: "button is-primary",
						disabled: () => page.loading,
						onclick: onClickAddTrial,
					},
					"Add trial",
				),
			),
		),
		hr(),
		div(
			{
				class: "field",
			},
			div(
				{
					class: "control",
				},
				input({
					class: "input",
					oninput: (e) => {
						page.fota.url = e.target.value;
					},
					value: () => page.fota.url,
				}),
			),
		),
		div(
			{
				class: "field",
			},
			div(
				{
					class: "control",
				},
				input(
					{
						class: "input",
						oninput: (e) => {
							page.fota.checksum = e.target.value;
						},
						placeholder: "Checksum",
					},
					() => page.fota.checksum,
				),
			),
		),
		div(
			{
				class: "field",
			},
			div(
				{
					class: "control",
				},
				button(
					{
						class: () =>
							page.loading
								? "button is-primary is-loading"
								: "button is-primary",
						disabled: () => page.loading,
						onclick: onClickUploadFota,
					},
					"Upload FOTA config",
				),
			),
		),
		hr(),
		pre({ class: "is-tiny-mobile" }, () =>
			JSON.stringify(page.fa2, null, 2),
		),
	);
}
